import React, { useContext, useEffect, useState } from "react";
import css from "../css/Mywallet.module.css";
import Rightcontainer from "../Components/Rightcontainer";
import { Link, useHistory } from "react-router-dom";
import axios from "axios";
import socket from "../Components/socket";
import { AiOutlineHistory, AiOutlinePlus } from "react-icons/ai";
import { BsWallet2 } from "react-icons/bs";
import io from "../Components/socket";
import { LanguageContext } from "../Components/LanguageContext";
import { useTheme } from "../../ThemeContext";
import { VscReferences } from "react-icons/vsc";

const Mywallet = ({ user }) => {
  const access_token = localStorage.getItem("token");

  const translations = {
    hi: {
      wallet: "वॉलेट",
      history: "इतिहास देखे | ",
      amount: "पैसे जोड़ें | ",
      withdraw: "पैसे निकाले  | ",
      referPerson: "रेफ़रल | ",
    },
    en: {
      wallet: "My Wallet",
      history: "Order History",
      amount: "Add Cash",
      withdraw: "Withdraw",
      referPerson: "Referral",
    },
  };

  const { language } = useContext(LanguageContext);

  // change theme
  const theme = localStorage.getItem("theme");

  const styles = {
    backgroundColor: theme === "light" ? "#fff" : "#000",
    color: theme === "light" ? "black" : "#fff",
  };

  return (
    <>
      <div
        className="leftContainer pt-5 mt-3 mb_space"
        style={{ ...styles, height: "100vh" }}
      >
        <div className="wallet-container">
          <div className="wallet-header">
            <div className="header-content">
              <h3 className="section-title">My Balance</h3>
              <p className="wallet-subtitle">Manage your funds and winnings</p>
            </div>
            <div className="total-balance-chip">
              <span className="chip-label">Total Balance</span>
              <span className="chip-value">₹{user && user?.Wallet_balance}</span>
            </div>
          </div>

          <div className="wallet-stats-grid">
            {/* Deposit Card */}
            <div className="stat-card deposit-variant">
              <div className="stat-content">
                <div className="stat-icon">
                  <img src="/images/icons/wallet.png" alt="Deposit" />
                </div>
                <div className="stat-details">
                  <span className="stat-label">Deposit Cash</span>
                  <h2 className="stat-amount">
                    ₹{user && user?.Wallet_balance - user?.withdrawAmount}
                  </h2>
                </div>
              </div>
              <div className="stat-footer">
                <Link className="full-width-link" to="/addcase">
                  <button className="modern-action-btn deposit-btn">
                    <AiOutlinePlus />
                    <span>{translations[language].amount}</span>
                  </button>
                </Link>
              </div>
            </div>

            {/* Winning Card */}
            <div className="stat-card winning-variant">
              <div className="stat-content">
                <div className="stat-icon">
                  <img src="/images/icons/bank.gif" alt="Winning" />
                </div>
                <div className="stat-details">
                  <span className="stat-label">Winning Cash</span>
                  <h2 className="stat-amount">
                    ₹{user && user?.withdrawAmount}
                  </h2>
                </div>
              </div>
              <div className="stat-footer">
                <Link className="full-width-link" to="/Withdrawopt">
                  <button className="modern-action-btn winning-btn">
                    <BsWallet2 />
                    <span>{translations[language].withdraw}</span>
                  </button>
                </Link>
              </div>
            </div>
          </div>
        </div>

        <div className="rightContainer">
          <div>
            <Rightcontainer />
          </div>
        </div>
      </div>
    </>
  );
};
export default Mywallet;
